module.exports = __webpack_public_path__ + "static/img/employe@2x.fd576f12.png";